<template>
  <BaseCard
    ref="base-card"
    :loading="loading"
    :title-visible="false"
    :footer-visible="false"
  >
    <template #title-free>
      <b-row class="mt-1 mx-1" align-v="center" align-h="end">
        <b-col>
          <div class="d-flex justify-content-end">
            <b-link
              v-if="!readonly || isSuperAdmin"
              v-access="{
                resource: $data.$constants.RESOURCES.RESOURCE_JOBS,
                resourceAction:
                  $data.$constants.RESOURCE_ACTIONS.RESOURCE_ACTION_ALL,
              }"
              :to="{ name: 'editJob', params: { id: $route.params.id } }"
              class="d-inline-block text-indigo btn btn-primary btn-sm rounded-sm me-1"
            >
              <feather-icon
                v-b-tooltip.hover
                title="Editar job"
                icon="Edit2Icon"
                size="18"
              />
              <span>Editar job</span>
            </b-link>
            <b-link
              v-if="!readonly && isSuperAdmin"
              v-access="{
                resource: $data.$constants.RESOURCES.RESOURCE_JOBS,
                resourceAction:
                  $data.$constants.RESOURCE_ACTIONS.RESOURCE_ACTION_ALL,
              }"
              @click="handleDeleteButtonClick()"
              class="me-4"
            >
              <span
                class="d-inline-block text-danger btn btn-danger btn-sm rounded-sm"
              >
                <feather-icon
                  v-b-tooltip.hover
                  title="Eliminar job"
                  icon="TrashIcon"
                  size="18"
                />
                <span>Eliminar job</span>
              </span>
            </b-link>
          </div>
        </b-col>
      </b-row>
      <b-row class="mx-1" align-v="center" align-h="between">
        <b-col sm="12" md="4" class="job-name-container">
          <small>{{ job ? job.code : "" }}</small>
          <h2 class="font-weight-bold text-capitalize text-dark mb-0">
            {{ job ? job.name : "" }}
          </h2>
          <small class="font-weight-bold">{{ jobDateText }}</small>
          <small
            v-if="job && job.without_warranty === '1'"
            class="pl-1 font-weight-bold"
            >(sin garantia)</small
          >
        </b-col>
        <b-col cols="auto" class="text-transform-none font-weight-normal">
          <StatusBadge class="font-small-3" :status="status" />
        </b-col>
        <b-col
          v-if="isMaintenance"
          sm="12"
          md="3"
          class="d-flex align-items-center"
        >
          <div class="d-flex align-items-center pt-1" style="width: 100%">
            <b-form-group label="Contrato" label-for="certification-client">
              <BaseSelect
                style="width: 15svw !important"
                label="name"
                :clearable="false"
                :placeholder="'Contrato'"
                :value="contractSelected.contract"
                :http-body="{ job_id: job.id }"
                :resource="$data.$constants.RESOURCES.RESOURCE_JOBS_CONTRACTS"
                @input="handleContractSelected($event)"
              />
            </b-form-group>
            <b-link
              v-if="contractSelected.contract"
              @click="showRangeContractModal = true"
              class="text-indigo"
            >
              <feather-icon
                class="ml-1"
                title="Editar"
                icon="Edit2Icon"
                size="18"
              />
            </b-link>
          </div>
        </b-col>
        <b-col v-if="!isMaintenance" sm="12" md="3" class="my-1">
          <div v-if="!readonly" class="d-inline-block">
            <b-form-checkbox
              class="mb-1"
              :checked="signedContract"
              value="1"
              :unchecked-value="0"
              @change="handleSignedContractCheckboxChange"
            >
              Contrato firmado
            </b-form-checkbox>
            <div class="d-flex align-items-start flex-column">
              <BaseFileInput
                ref="contract-file-input"
                class="d-inline"
                :multiple="true"
                @change="handleContractInputChange"
              >
                <b-link class="text-indigo d-flex align-items-center flex-row" >
                  <feather-icon
                    icon="UploadIcon"
                    size="19"
                    style="margin-right: 8px; margin-bottom: 5px"
                  />
                  <span> Subir contratos </span>
                </b-link>
              </BaseFileInput>
              <div>
                <div v-if="contractVisible">
                <span v-for="file in contractFiles" :key="file.id" class="d-flex align-items-center mt-1 flex-row">
                  <div class="contract-container">
                    <b-link
                      size="sm"
                      class="text-decoration-none text-indigo"
                      @click="handleDownloadContractLinkClick(file)"
                    >
                      <u>{{ file.name }}</u>
                    </b-link>
                  </div>
                  <b-link @click="handleDeleteContractButtonClick(file.id)">
                    <span class="d-inline-block text-danger">
                      <feather-icon
                        v-b-tooltip.hover
                        title="Eliminar"
                        icon="TrashIcon"
                        size="18"
                      />
                    </span>
                  </b-link>
                </span>
              </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col md="3" class="d-flex justify-content-end">
          <div>
            <template v-if="daysEndActiveContract">
              <div class="d-flex justify-content-end">
                <b-button
                  v-if="showRenewButton"
                  variant="primary"
                  class="rounded-sm px-2 my-1"
                  @click="showRenewContractModal = true"
                >
                  Renovar
                </b-button>
              </div>
              <span v-if="showRenewMessage" class="text-danger">
                {{ showRenewMessage || "" }}
              </span>
            </template>
            <template v-if="!isMaintenance">
              <div
                v-if="initialCostPreviewDocument"
                class="text-transform-none font-weight-normal p-1"
              >
                <div>
                  <b-link
                    class="text-decoration-none text-indigo font-small-3"
                    @click="handleInitialCostPreviewDownload"
                  >
                    <feather-icon icon="DownloadIcon" size="19" class="mr-25" />
                    <u>{{
                      initialCostPreviewDocument
                        ? initialCostPreviewDocument.name
                        : ""
                    }}</u>
                  </b-link>
                </div>
                <div>
                  <label>
                    {{
                      initialCostPreviewDocumentUser
                        ? initialCostPreviewDocumentUser.full_name
                        : ""
                    }}
                    -
                    {{ initialCostPreviewDocumentDate | formatDate }}
                  </label>
                </div>
              </div>
              <div v-if="showGeneratePrevisionButton">
                <b-button
                  v-if="!readonly"
                  variant="primary"
                  class="rounded-sm px-2 mt-1"
                  @click="handleInitialCostPreviewButtonClick"
                >
                  {{
                    initialCostPreviewDocumentUser
                      ? "Regenerar previsión costes inicial"
                      : "Generar previsión costes inicial"
                  }}
                </b-button>
              </div>
            </template>
          </div>
        </b-col>
      </b-row>
      <b-row class="m-1">
        <b-col cols="8">
          <div class="d-flex align-items-center">
            <div
              v-if="job && job.is_cri === 1 && job.subscriber_number"
              class="mr-1"
            >
              <div class="font-weight-bold">Nº de abonado:</div>
              <div class="text-light">
                {{ job ? job.subscriber_number : "" }}
              </div>
            </div>
            <div v-if="relatedJob">
              <div class="font-weight-bold">JOB vinculado:</div>
              <b-link class="text-indigo" @click="goToRelatedJob()">
                <u>
                  {{ relatedJob.name || "" }}
                </u>
              </b-link>
            </div>
          </div>
        </b-col>
        <b-col md="4" class="d-flex justify-content-end pt-1">
          <div v-if="offer" style="font-size: 15px">
            <div class="font-weight-bold d-flex justify-content-end pb-1">
              <span>Oferta de origen:</span>
            </div>
            <b-link
              class="text-indigo"
              @click="
                $router.push({ name: 'viewOffer', params: { id: offer.id } })
              "
            >
              <u>{{ offer.name }}</u>
            </b-link>
          </div>
        </b-col>
      </b-row>
      <div v-if="job && job.related_jobs.length > 0" class="m-1">
        <div class="font-weight-bold">JOBS relacionados:</div>
        <b-row>
          <b-col>
            <div v-for="relatedJob in job.related_jobs" :key="relatedJob.id">
              <b-link
                class="text-indigo"
                @click="goToRelatedJob(relatedJob.id)"
              >
                <u>{{ relatedJob.name }}</u>
              </b-link>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
    <ProfilePanel :profile="jobProfile" />
    <ContactsPanel
      v-if="job && job.contacts.length > 0"
      :contacts="job.contacts"
    />
    <JobRenewContractModal v-model="showRenewContractModal" />
    <JobRangeContractModal v-model="showRangeContractModal" :jobId="jobId" />
  </BaseCard>
</template>
<script>
import JobsApi from "@/api/jobs-api";
import ApiRestService from "@/api/base-api";
import { mapActions, mapGetters } from "vuex";
import StatusBadge from "@/components/status/badge/StatusBadge.vue";
import ProfilePanel from "@/components/ui/panel/ProfilePanel.vue";
import ContactsPanel from "@/components/ui/panel/ContactsPanel.vue";
import BaseFileInput from "@/components/ui/file/BaseFileInput.vue";
import BaseCard from "@/components/ui/card/BaseCard.vue";
import BaseSelect from "@/components/ui/select/BaseSelect.vue";
import JobRenewContractModal from "@/components/jobs/modal/JobRenewContractModal.vue";
import JobRangeContractModal from "@/components/jobs/modal/JobRangeContractModal.vue";
import job from "@/store/job";

export default {
  name: "JobProfileCard",
  components: {
    BaseCard,
    BaseFileInput,
    ProfilePanel,
    StatusBadge,
    ContactsPanel,
    BaseSelect,
    JobRenewContractModal,
    JobRangeContractModal,
  },
  data() {
    return {
      loading: false,
      signedContractCheckboxTimeout: null,
      showRenewContractModal: false,
      showRangeContractModal: false,
    };
  },
  computed: {
    ...mapGetters("job", {
      job: "getJob",
      isMaintenance: "getIsMaintenance",
      readonly: "getIsReadOnlyMode",
      daysEndActiveContract: "getDaysEndActiveContract",
    }),
    jobId() {
      return this.job?.id;
    },
    jobProfile() {
      const columns = [
        {
          label: "Project Manager",
          value: this.job?.user?.full_name || "Sin Project Manager",
        },
        {
          label: "División",
          value: this.job?.division?.name || "Sin división",
        },
        {
          label: "Cliente",
          value: this.job?.client?.name || "Sin cliente",
          link: true,
          routeName: "viewClient",
          id: this.job?.client?.id,
        },
        {
          label: "Obra",
          value: this.job?.project?.name || "Sin obra",
          link: true,
          routeName: "viewProject",
          id: this.job?.project?.id,
        },
        { label: "Provincia", value: this.job?.project?.province?.name || "" },
        {
          label: "Referencia cliente",
          value:
            (this.isMaintenance
              ? this.contractSelected?.contract?.ref_client
              : this.job?.ref_client) || "Sin referencia cliente",
        },
      ];

      if (this.job?.is_warranty_job === 1) {
        if (this.job?.warranty_start_date) {
          columns.push({
            label: "Fecha inicio garantía",
            value: this.job?.warranty_start_date
              ? new Date(this.job?.warranty_start_date).toLocaleDateString()
              : "",
          });
        }

        if (this.job?.warranty_end_date) {
          columns.push({
            label: "Fecha fin garantía",
            value: this.job?.warranty_end_date
              ? new Date(this.job?.warranty_end_date).toLocaleDateString()
              : "",
          });
        }
      }

      return columns;
    },
    jobDateText() {
      if (!this.job || !this.job.job_date) {
        return "Sin fecha de job";
      }

      return new Date(this.job.job_date).toLocaleDateString();
    },
    relatedJob() {
      return this.job?.related_job;
    },
    signedContract() {
      return this.job?.signed_contract;
    },
    status() {
      return this.job?.status?.name || "";
    },
    contractVisible() {
      return this.job?.contract?.length > 0;
    },
    contractFiles() {
      return this.contractVisible ? this.job.contract : [];
    },
    initialCostPreviewDocument() {
      const document = this.job?.start_document?.document || null;
      if (!document || document.length === 0) {
        return null;
      }

      return document;
    },
    initialCostPreviewDocumentUser() {
      return this.job?.start_document?.user;
    },
    initialCostPreviewDocumentDate() {
      return this.job?.start_document?.date;
    },
    isSuperAdmin() {
      return (
        JSON.parse(localStorage.getItem("userData")).roles[0].name ===
        "super_admin"
      );
    },
    contractSelected() {
      return this.$store.getters["job/getContractSelected"](this.job.id);
    },
    showRenewButton() {
      return this.daysEndActiveContract <= 10 && this.isMaintenance;
    },
    showRenewMessage() {
      if (this.isMaintenance) {
        let message = null;
        if (this.daysEndActiveContract <= 10) {
          message = `Quedan ${this.daysEndActiveContract} días hasta finalizar el contrato`;
        }
        if (this.daysEndActiveContract <= 0) {
          message = "No se dispone de un contrato activo";
        }
        return message;
      }
    },
    offer() {
      return this.job?.offer;
    },
    showGeneratePrevisionButton() {
      if (this.isSuperAdmin) {
        return true;
      } else {
        return !this.initialCostPreviewDocument;
      }
    },
  },
  methods: {
    ...mapActions("job", ["setJob", "loadJob"]),
    async handleDeleteButtonClick() {
      const response = await this.$modal.show({
        title: "¿Está seguro?",
        text: `Se borrará el registro ${this.job.name}.`,
      });

      if (!response.isConfirmed) {
        return;
      }

      try {
        this.loading = true;
        await JobsApi.delete(this.job.id);
        await this.$router.push({ name: "jobs" });
      } finally {
        this.loading = false;
      }
    },
    async handleContractInputChange(contract) {
      this.loading = true;
      try {
        const signed_contract =
          contract && contract.length > 0 && contract[0] ? 1 : 0;
        const jobToUpdate = { ...this.job, contract, signed_contract };
        delete jobToUpdate.documentation;
        const response = await JobsApi.edit(this.job.id, jobToUpdate);
        this.setJob(response.data);
      } finally {
        this.loading = false;
      }
    },
    handleSignedContractCheckboxChange(signed_contract) {
      if (this.signedContractCheckboxTimeout) {
        clearTimeout(this.signedContractCheckboxTimeout);
      }

      this.signedContractCheckboxTimeout = setTimeout(() => {
        const jobToUpdate = { ...this.job, signed_contract };
        delete jobToUpdate.contract;
        delete jobToUpdate.documentation;
        JobsApi.edit(this.job.id, jobToUpdate);
      }, 500);
    },
    async handleDeleteContractButtonClick(id) {
      const response = await this.$modal.show({
        title: "¿Está seguro de eliminar?",
        text: "Se borrará el contrato",
      });

      if (!this.contractVisible || !response.isConfirmed) {
        return;
      }

      this.loading = true;
      try {
        await JobsApi.deleteContract(this.job.id, id);
        await this.loadJob(this.job?.id);
        this.$refs["contract-file-input"].cleatFileInput();
      } finally {
        this.loading = false;
      }
    },
    async handleDownloadContractLinkClick(file) {
      this.loading = true;
      try {
        await ApiRestService.downloadArchive(file.id, file.name);
      } finally {
        this.loading = false;
      }
    },
    async handleInitialCostPreviewButtonClick() {
      this.loading = true;
      try {
        await JobsApi.printJob(this.job?.id);
        await this.loadJob(this.job?.id);
      } finally {
        this.loading = false;
      }
    },
    async handleInitialCostPreviewDownload() {
      this.loading = true;
      try {
        await ApiRestService.downloadArchive(
          this.initialCostPreviewDocument.id,
          this.initialCostPreviewDocument.name
        );
      } finally {
        this.loading = false;
      }
    },
    setCollapse(collapse) {
      this.$refs["base-card"].setCollapse(collapse);
    },
    handleContractSelected(contract) {
      this.loading = true;
      const value = { job_id: this.job.id, contract: contract };
      this.$store.dispatch("job/setContractSelected", value);
      window.location.reload();
    },
    goToRelatedJob(id) {
      window.location.href = `/jobs/view/${id}`;
    },
  },
};
</script>

<style scoped>
.contract-container {
  width: 100%;
  text-overflow: ellipsis;
  white-space: wrap;
  overflow: hidden;
  display: inline-block;
}

.job-name-container {
  max-width: 90%;
}
.me-1 {
  margin-right: 1rem;
}
</style>
